<template>
    <div>
      <div class="row">
        <div class="col-6">
          <i class="ml-2 bi bi-question-circle-fill" data-toogle="tooltip" title="Sunburst is representative of numbers of reads for taxon selected and sub-taxonomy.This is a navigable plot"
             v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover></i>
        </div>
        <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
          <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
             v-bind:style="{ fontSize : '15px'}"></i>
          <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
          <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
             v-b-modal="componentId+'-modal-save'"></i>
          <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
             v-bind:style="{ fontSize : '12px'}"></i>
        </div>
      </div>
        <div class="widget-legend legend">
            <span>Taxonomic Sunburst on {{ fraction }} µm at depth {{ depth }}</span>
        </div>
        <SunburstWidget :plotData="plotData" :componentId="componentId">
        </SunburstWidget>
        <div>
            <b-modal :id="componentId+'-modal'" title="Richness by asv">
                <div class="form-group mt-2" style="font-size: 1.6vmin;">
                    <template>
                        <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group
                                    :id="componentId+'radio-group-2'"
                                    v-model="fraction"
                                    :options="fractions"
                                    :aria-describedby="ariaDescribedby"
                                    name="fraction-options"
                            ></b-form-radio-group>
                        </b-form-group>
                    </template>
                </div>
                <div class="form-group mt-2">
                    <b-form-group label="Depth">
                        <select v-model="depth" class="form-control">
                            <option v-for="option in depthCodes" v-bind:key="option.depth" :value="option.depth">
                                {{ option.depth }}
                            </option>
                        </select>
                    </b-form-group>
                </div>
                <div>
                    <b-form-checkbox
                            :id="componentId+'advanced'"
                            v-model="advanced"
                            name="advanced_splitting"
                            value="checked"
                            unchecked-value="not_checked"
                    >
                        Advanced Splitting
                    </b-form-checkbox>
                </div>
                <div class="form-group mt-2" style="font-size: 1.6vmin;" v-if="advanced === 'checked'">
                    <template>
                        <b-form-group label="Splitting : " v-slot="{ ariaDescribedby }">
                            <b-form-radio-group
                                    :id="componentId+'radio-group-advanced'"
                                    v-model="splitBy"
                                    :options="advancedSplittingOptions"
                                    :aria-describedby="ariaDescribedby"
                                    name="split-options"
                            ></b-form-radio-group>
                        </b-form-group>
                    </template>
                </div>
            </b-modal>
        </div>
        <b-modal :id="componentId+'-legend'" title="Legend">
            HTML allowed
            <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

            <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
        </b-modal>

        <ExportDialog :componentId="componentId" :plotData="plotData" :formattedData="formattedData" :exportFileName="exportFileName"
                      :dataset="dataset" :legend="legend"></ExportDialog>
        <div>
            <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
                <b-card>
                    <div v-html="legend">
                    </div>

                </b-card>
            </b-collapse>
        </div>

    </div>
</template>

<script>/* eslint-disable */

import axios from "axios";
import {mapActions} from "vuex";
import {ApiCall} from "../mixins/ApiMixin";
import SunburstWidget from "./SunburstWidget";
import ExportDialog from "./ExportDialog.vue";

export default {
    name: "Sunburst",
    props: ['panelId', 'componentId', 'triggerValue', 'settings'],
    mixins: [ApiCall],
    components: {
        SunburstWidget,
        ExportDialog
        ,
    },
    data() {
        return {
            dataset: null,
            advanced: "not_checked",
            splitBy: null,
            advancedSplittingOptions: [
                {text: 'By Depth', value: 'depth'},
                {text: 'By Year', value: 'year'},
            ],

            rank: null,
            searchPanelTaxon: null,

            dateStart: null,
            dateEnd: null,
            date: [],
            visible: false,
            asv: null,
            legend: null,
            fractions: [],
            fraction: null,
            depthCodes: {},
            depth: null,
            formattedData: null,
            plotData: null,

            settingsHash: "",
            exportFileName: "mygod_sunburst",
            apiCallsInProgress: 0
        }
    },
    watch: {
        triggerValue() {
            this.updateContents()
        },
        fraction() {
            this.getPlotData()
        },
        depth() {
            this.getPlotData()
        },
        advanced() {
            if (this.advanced === 'not_checked') {
                this.splitBy = null
            }
        },
        splitBy() {
            this.getPlotData()
        },
        legend() {
            this.updateDashboardWidgetLegend({
                'componentId': this.componentId,
                'legend': this.legend
            })
        },
        plotData() {
            this.flattenNestedData()
        }
    },
    created() {
        this.updateContents()
    },

    methods: {

        ...mapActions([
            'updateDashboardWidgetSettings',
            'cloneWidget'
        ]),

        flattenNestedData() {

            let tmpPlotData = []
            tmpPlotData.push(this.plotData)
            const getMembers = (members) => {
                let children = [];

                return members.map(mem => {
                    const m = {...mem};
                    if (m.children && m.children.length) {
                        children = [...children, ...m.children];
                    }
                    delete m.children;
                    return m;
                }).concat(children.length ? getMembers(children) : children);
            };
            this.formattedData = getMembers(tmpPlotData);
        },

        updateContents() {
            let panel = this.$store.state.panels[this.panelId]

            let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
            if (newPanelSettingsHash === this.settingsPanelHash) {
                return
            }
            this.settingsPanelHash = newPanelSettingsHash
            this.plotData = null

            this.dataset = panel.dataset
            this.rank = panel.rank
            this.searchPanelTaxon = panel.taxon
            this.dateStart = panel.dateStart
            this.dateEnd = panel.dateEnd

            this.initializeFractionSizes()
            this.initializeLegend()
            this.initializeSplitBy()
            this.initializeDepthCode()
            this.getPlotData()

        },

        getPlotData() {
            if (this.apiCallsInProgress > 0) {
                setTimeout(this.getPlotData, 2000)
                return
            }
            if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.searchPanelTaxon && this.depth) {
                let newSettingsHash = this.dataset + this.searchPanelTaxon + this.rank + this.fraction + this.dateStart + this.dateEnd + this.depth + this.splitBy
                if (newSettingsHash === this.settingsHash) {
                    return
                }

                this.settingsHash = newSettingsHash
                this.plotData = null

                this.updateDashboardWidgetSettings({
                    'componentId': this.componentId,
                    'settings': {
                        'dataset': this.dataset,
                        'taxon': this.searchPanelTaxon,
                        'fraction': this.fraction,
                        'dateStart': this.dateStart,
                        'dateEnd': this.dateEnd,
                        'depth': this.depth,
                        'splitBy': this.splitBy,
                        'legend': this.legend
                    }
                })

                let me = this
                axios
                    .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['nested_abundances_taxon',
                    this.dataset, this.rank, this.searchPanelTaxon, this.fraction, this.dateStart, this.dateEnd,
                    this.depth]))
                    .then(function (response) {
                        me.plotData = response.data
                    })
            } else {
                console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
            }
        },
    }
}
</script>

<style scoped>

</style>